// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2gjf9","modalForm":"UpgradeEpcsModal_modalForm__1XZVT","modalFooter":"UpgradeEpcsModal_modalFooter__3StT8"};